<script setup lang="ts">
withDefaults(defineProps<{
  as?: string
  highlight?: string
  highlightColor?: 'chalk' | 'red' | 'yellow'
  level?: 1 | 2 | 3
}>(), {
  as: undefined,
  highlight: undefined,
  highlightColor: 'yellow',
  level: 1,
})
</script>

<template>
  <component
    :is="as ?? `h${level}`"
    class="font-editorial italic font-black leading-[0.95] tracking-[-0.01em]"
    :class="[
      level === 1 ? 'text-hero' : level === 2 ? 'text-display' : 'text-sticker-lg',
    ]"
  >
    <template v-if="highlight">
      <slot/>
      <span
        class="inline-block align-baseline font-display not-italic font-normal px-3 py-1 mx-1 rounded-[4px] leading-none"
        :style="{
          background: `var(--color-brand-${highlightColor})`,
          color: highlightColor === 'chalk' ? 'var(--color-brand-ink)' : 'var(--color-brand-ink)',
          transform: 'rotate(-1.5deg)',
        }"
      >{{ highlight }}</span>
      <slot name="after"/>
    </template>
    <template v-else>
      <slot/>
    </template>
  </component>
</template>
